'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { useFieldContext } from './FieldContext';
import styles from './Field.module.css';
/**
 * Compound member of <Field>. Renders helper text linked into the control's
 * aria-describedby chain via FieldContext.
 *
 * A block element carrying caption typography, so the description may hold
 * several lines (e.g. a `<Stack gap="xs">` of `<Caption>`s) and every line is
 * still read as part of the control's description.
 */
export function FieldDescription({ children }) {
    const ctx = useFieldContext();
    const register = ctx?.registerMessage;
    useLayoutEffect(() => register?.('description'), [register]);
    return (_jsx("div", { id: ctx?.ids.description, className: styles.description, children: children }));
}
//# sourceMappingURL=FieldDescription.js.map